import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import ArrowForward from "@material-ui/icons/ArrowForward"
import { useEtoroUser } from "../../../contexts/EtoroUserContext";

// @material-ui/icons components

// core components

import componentStyles from "assets/theme/components/cards/cards/card-news.js";
import componentStylesCardImg from "assets/theme/components/card-img.js";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(componentStyles);
const useStylesCardImg = makeStyles(componentStylesCardImg);

function CardNews({ ticker, date, image, title, description, source, url }) {
  const classes = { ...useStyles(), ...useStylesCardImg() };
  const theme = useTheme();
  const { currentEtoroUserData } = useEtoroUser();
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'News' });

  let companyLogo = ""; 
  let utm = "?utm_source=bullsheet&utm_medium=referral";
  let asset = currentEtoroUserData?.userInstruments ? currentEtoroUserData.userInstruments.instruments.find(entry => entry.ticker === ticker) : undefined;
  if (!asset) {
    asset = currentEtoroUserData?.userInstruments.parentInstruments ? currentEtoroUserData.userInstruments.parentInstruments.find(entry => entry.ticker === ticker) : undefined;
  }
  if (!asset) {
    asset = currentEtoroUserData?.cryptoData?.latestCryptoData?.latestCryptoFundamentals ? currentEtoroUserData.cryptoData.latestCryptoData.latestCryptoFundamentals.find(entry => entry.ticker === ticker) : undefined;
  }
  if (asset) {
    companyLogo = asset.media ? asset.media[asset.media.findIndex(x => x.width == 150)].uri : asset.logo;
  }

  function handleClick(){
    window.open(url + utm, "_blank");
  }
  return (
    <>
      <Card className={classes.cardRoot}>
        <img
          alt="..."
          src={image}
          className={classes.cardImgTop}
          onError={(e) => {e.currentTarget.onError=null;e.currentTarget.src='data:image/png;base64,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'}}
        />
        <CardContent>
          
          <Box
            component="small"
            fontSize={theme.typography.h5.fontSize}
            fontWeight="600"
            color={theme.palette.bsColors.MainBlue}
          >
            <Box
              component={Avatar}
              classes={{ root: classes.companyLogo }}
              alt="..."
              src={companyLogo}
            />

            {ticker}
          </Box>
          <Box
            component="p"
            fontSize={theme.typography.h5.fontSize}
            fontWeight="400"
            color={theme.palette.gray[600]}
          >
            {source} - {date}
          </Box>
          <Box component={Typography} variant="h3" marginBottom="0!important">
            {title?.length > 62 ? 
              title.substring(0,60)+"..."
            :
              title
            }
          </Box>
          <Box
            component="p"
            marginBottom="1rem"
            fontWeight="300"
            lineHeight="1.7"
            fontSize={theme.typography.h4.fontSize}
            marginTop="1.2rem"
          >
            {description?.length > 180 ? 
              description.substring(0,180)+"..."
            :
              description
            }
          </Box>
          <Box>
          <Button onClick={handleClick}
            variant="text"
            disableRipple
            component={Box}
            padding="0!important"
            style={{float:"right", color: theme.palette.bsColors.LogoLightBlue, right:"25px", bottom:"20px", position:"absolute"}}
          >
            {t("seeMore")} <ArrowForward/>
          </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default CardNews;
